import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    labelContainer: {
      '& > p:first-child': {
        fontWeight: 600,
        fontSize: '1.8rem',
      },
    },
  }),
)
